import React from 'react';
import { Container } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { FaQuestionCircle } from 'react-icons/fa';

const CommonQue = () => {
  return (
    <Container  fluid className='mb-5'>
      <h2 className="text-center mb-5 txt">Frequently Asked Questions</h2>
      <Accordion defaultActiveKey="0" alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            What are the signs of anxiety disorders?
          </Accordion.Header>
          <Accordion.Body>
            Anxiety disorders can manifest in various forms such as excessive worry, rapid heartbeat, difficulty concentrating, and avoiding situations that trigger anxiety. If left untreated, anxiety can affect daily life.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            How can therapy help with depression?
          </Accordion.Header>
          <Accordion.Body>
            Therapy can provide you with coping strategies, tools to manage negative thoughts, and emotional support. Cognitive Behavioral Therapy (CBT) is a common approach used to treat depression effectively.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            What is the difference between a therapist and a psychiatrist?
          </Accordion.Header>
          <Accordion.Body>
            A therapist provides talk therapy and counseling to help individuals with emotional and psychological issues. A psychiatrist is a medical doctor who can diagnose mental health conditions and prescribe medication when necessary.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            How do I know if I need therapy or medication?
          </Accordion.Header>
          <Accordion.Body>
            Both therapy and medication can help, and often they are used together. If you're experiencing severe symptoms such as constant sadness, inability to function, or overwhelming anxiety, it's important to consult a professional to determine the best treatment approach for you.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            Can mental health issues be treated without medication?
          </Accordion.Header>
          <Accordion.Body>
            Yes, mental health issues can be treated without medication through various therapies such as CBT, mindfulness practices, and lifestyle changes. However, for some individuals, medication may be recommended as part of a comprehensive treatment plan.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <FaQuestionCircle className="mr-2" size={20} />
            How do I cope with stress and overwhelming emotions?
          </Accordion.Header>
          <Accordion.Body>
            Stress can be managed through deep breathing exercises, mindfulness, physical activity, and seeking support from loved ones or a therapist. Identifying the sources of stress and developing healthy coping strategies are essential.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default CommonQue;
